/**
 * Script Loader - Lazy loading de scripts com Intersection Observer
 * Carrega scripts dinamicamente quando sections ficam visíveis
 */
(function() {
    'use strict';

    // Cache de scripts já carregados para evitar duplicação
    const loadedScripts = new Set();
    const loadingScripts = new Set();

    /**
     * Sincroniza scripts já presentes no DOM para o cache
     */
    function syncExistingScripts() {
        document.querySelectorAll('script[src]').forEach(script => {
            const src = script.getAttribute('src');
            if (src) loadedScripts.add(src);
        });
    }

    /**
     * Carrega um script dinamicamente
     * @param {string} src - URL do script
     * @param {Function} callback - Callback opcional após carregamento
     */
    function loadScript(src, callback) {
        // Se já está carregado, apenas executa callback
        if (loadedScripts.has(src)) {
            if (callback) callback();
            return Promise.resolve();
        }

        // Se já está carregando, aguarda
        if (loadingScripts.has(src)) {
            return new Promise((resolve) => {
                const checkInterval = setInterval(() => {
                    if (loadedScripts.has(src)) {
                        clearInterval(checkInterval);
                        if (callback) callback();
                        resolve();
                    }
                }, 50);
            });
        }

        // Marca como carregando
        loadingScripts.add(src);

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.defer = true;

            script.onload = () => {
                loadedScripts.add(src);
                loadingScripts.delete(src);
                if (callback) callback();
                resolve();
            };

            script.onerror = () => {
                loadingScripts.delete(src);
                console.warn(`[ScriptLoader] Error: ${src}`);
                reject(new Error(`Failed to load script: ${src}`));
            };

            document.head.appendChild(script);
        });
    }

    /**
     * Inicializa o lazy loading de scripts
     */
    function initLazyScriptLoader() {
        syncExistingScripts();
        const lazyScriptElements = document.querySelectorAll('[data-lazy-script]');

        if (!lazyScriptElements.length) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const scriptSrc = element.getAttribute('data-lazy-script');

                    if (scriptSrc && !loadedScripts.has(scriptSrc)) {
                        loadScript(scriptSrc).then(() => {
                            // Remove o elemento placeholder após carregar
                            element.remove();
                        }).catch(err => {
                            console.warn('Script loader error:', err);
                        });
                    }

                    observer.unobserve(element);
                }
            });
        }, {
            rootMargin: '200px' // Carrega 200px antes da section ficar visível
        });

        lazyScriptElements.forEach(element => {
            const scriptSrc = element.getAttribute('data-lazy-script');

            // Verificar se o elemento já está visível
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight + 200 && rect.bottom > -200;

            if (isVisible && scriptSrc && !loadedScripts.has(scriptSrc)) {
                loadScript(scriptSrc).then(() => {
                    element.remove();
                }).catch(err => {
                    console.warn('Script loader error:', err);
                });
            } else {
                observer.observe(element);
            }
        });
    }

    // Inicializa quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLazyScriptLoader);
    } else {
        initLazyScriptLoader();
    }

    // Exporta função para uso externo se necessário
    window.lazyLoadScript = loadScript;
})();
